import { RootState } from 'data/root.reducers';
import { Diameter } from './diameter.types';

export const getDiameterList = (state: RootState): Diameter[] =>
  state.diameter.entities;

export const getDiameter = (state: RootState): Diameter | undefined =>
  state.diameter.entities?.[0];
